/**
 * react-select has an issue where it can't be set to "required"
 * This is a hacky fix which wraps react-select and allows "required" to be set
 * https://github.com/orther/react-select-v2-required-input
 *
 * This component must be controlled in order to work
 */

import React, { FC , createRef, useState } from 'react';
import Select from 'react-select';

interface RequireableSelectProps<T extends number | string> {
  required?: boolean;
  onChange: (val: { label: string, value: T }) => void;
  options: readonly { label: string, value: T }[];
  value: { label: string, value: T } | null;
  // can't figure out how to get the typings out of react-select, so just do hacky allow anything for now
  [key: string]: any;
}

const RequireableSelect = <T extends number | string>({ options, onChange, required, value, ...props }: RequireableSelectProps<T>) => {
  const selectRef = createRef<Select>();

  return (
    <div>
      <Select
        {...props}
        ref={selectRef}
        onChange={onChange}
        value={value as any}
        options={options as any}
      />
      {required && (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            width: '100%',
            height: 0,
            position: 'absolute',
          }}
          value={value?.value}
          onFocus={() => selectRef.current.focus()}
          required={required}
        />
      )}
    </div>
  );
};

export default RequireableSelect;
